export default __webpack_public_path__ + "./fonts/autorizaciones.43dcd897.svg";